/**
 * Pure helpers for `TransportationRoutes.tsx`, kept dependency-free (no React/MUI/store
 * imports) so they can be unit tested directly in this repo's Node-only vitest
 * environment without needing a DOM.
 */

/** Query-param values for the two Transportation Routes tabs. Task 4 renders the `schedule` panel's real content. */
export type TransportationRoutesTab = 'list' | 'schedule';

/** Resolves the `?tab=` search param to a known tab, defaulting to `list`. */
export function resolveTransportationRoutesTab(tabParam: string | null): TransportationRoutesTab {
  return tabParam === 'schedule' ? 'schedule' : 'list';
}
